<template>
  <div>
    <div class="my-header">
      <router-link to="/" class="logo-div">
        <img class="logo" src="/static/image/logo.png">

        <span>个人中心</span>
      </router-link>

      <div class="right">
        <div class="search">
          <div class="searchRight">
            <input type="text"
                   v-model="keyword"
                   @keyup.enter="searchPro"
                   @click="findSearchHistory"
                   placeholder="我要采购..."
            >
          </div>
          <span class="btn cur-poi" @click="searchPro">
          <i class="icon el-icon-search"></i> 搜索
        </span>

          <!-- 历史搜索 -->
          <div :style="{display: showHistory > 0 ? 'block':'none'}" class="historyBox">
            <div class="deleteBtn">
              <label class="fs14 font-color-DDD" @click="historyDelAll">删除历史</label>
            </div>
            <ul>
              <li
                v-for="(item, index) in historyList"
                :key="item.searchId"
                @click="historyKeyword(item.search)"
              >
                <span class="boxContent historyText line1" >{{item.search}}</span>
              </li>
            </ul>
          </div>
        </div>

        <div class="btn cur-poi cartbtn" @click="mycart">
          <i class="el-icon-shopping-cart-1"></i> 我的购物车
          <span v-if="isShowNum">
              <b v-text="cartNumber === 0 ? '0' : cartNumber"></b>
            </span>
        </div>
      </div>
    </div>
    <div class="userCenter">
      <div class="warp">
        <div class="leftMenu">
          <div class="leftMenuBox">
            <el-menu
              :default-active="defaultActive"
              active-text-color="#004097"
              router
            >
              <el-menu-item-group>
                <template slot="title">
                  <icon-svg
                    style="width: 30px; height: 30px;vertical-align: middle;"
                    icon-class="user-order"
                  />
                  我的订单
                </template>
                <el-menu-item class="flex-start" index="myOrder2"><span class="title">已确认订单</span></el-menu-item>
                <el-menu-item class="flex-start" index="myOrder"><span class="title">未确认订单</span></el-menu-item>
                <el-menu-item class="flex-start" index="orderAfterSale"><span class="title">售后订单</span></el-menu-item>

              </el-menu-item-group>

              <el-menu-item-group>
                <template slot="title">
                  <icon-svg
                    style="width: 30px; height: 30px;vertical-align: middle;"
                    icon-class="user-foot"
                  />
                  我的积分
                </template>
                <el-menu-item class="flex-start" index="integralList"><span class="title">我的积分</span></el-menu-item>
              </el-menu-item-group>


              <el-menu-item-group>
                <template slot="title">
                  <icon-svg
                    style="width: 30px; height: 30px;vertical-align: middle;"
                    icon-class="user-info"
                  />
                  账户设置
                </template>
                <el-menu-item class="flex-start" index="userInfo"><span class="title">个人信息</span></el-menu-item>
                <el-menu-item class="flex-start" index="signingAddress"><span class="title">收货地址</span></el-menu-item>
<!--                <el-menu-item class="flex-start" index="invoiceTitle"><span class="title">发票抬头</span></el-menu-item>-->
<!--                <el-menu-item class="flex-start" index="orderAfterSale"><span class="title">授权管理</span></el-menu-item>-->
                <!--                <el-menu-item class="flex-start" index="orderAfterSale"><span class="title">注销账户</span></el-menu-item>-->
              </el-menu-item-group>


              <el-menu-item-group>
                <template slot="title">
                  <icon-svg
                    style="width: 30px; height: 30px;vertical-align: middle;"
                    icon-class="user-foot"
                  />
                  我的信息
                </template>
<!--                <el-menu-item class="flex-start" index="couponPackage"><span class="title">我的卡券</span></el-menu-item>-->
                <el-menu-item class="flex-start" index="favorites"><span class="title">我的收藏</span></el-menu-item>
                <el-menu-item class="flex-start" index="message"><span class="title">我的消息</span></el-menu-item>
                <el-menu-item class="flex-start" index="qaList"><span class="title">我的问答</span></el-menu-item>
                <el-menu-item class="flex-start" index="myEvaluate"><span class="title">我的评价</span></el-menu-item>
                <el-menu-item class="flex-start" index="browseRecords"><span class="title">我的足迹</span></el-menu-item>
              </el-menu-item-group>
            </el-menu>
          </div>
        </div>
        <div class="userCenterInfo">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookie from "js-cookie";
import { mapGetters, mapMutations } from "vuex";
import {
  deleteAllSearch, getHistory
} from '@/api/nav.js'
export default {
  name: "userCenter",
  data() {
    return {
      keyword: '',
      searchVal: '宝贝',
      isShowNum: true,
      historyList: [],
      isLogin: false,
      showHistory: false
    }
  },
  created() {
    if (!Cookie.get("token")) {
      this.$message.warning("请先登录");
      this.$store.commit("resetVuex");
      // this.$router.push({path: '/login'})
      this.$store.commit("IS_LOGIN", false);
      this.$router.push({path: '/login?rtn=' + encodeURIComponent(this.$route.fullPath)})
    }else{
      this.isLogin = true

      let that = this;
      document.addEventListener('click',function(e){
        if(e.target.className != 'historyTar'){
          that.showHistory = false
        }
      })
    }
  },
  computed: {
    ...mapGetters(["userInfo", 'cartNumber']),
    defaultActive: function () {
      return this.$route.path.replace("/", "");
    },
  },
  watch: {
    '$store.state.isLogin': {
      handler (nVal, oVal) {
        this.isLogin = nVal
      }
    }
  },
  methods: {
    ...mapMutations({
      setSearchObj: 'SET_SEARCHOBJ'
    }),
    // 查找
    searchPro () {
      this.$store.commit('SHOW_HISTORY', false)

      if (!this.keyword) { return this.$message.error('请输入搜索内容') }

      let obj = {
        keyword: this.keyword,
        searchVal: this.searchVal
      }

      this.setSearchObj(obj)

      if (this.$route.name !== 'search') {
        this.$router.push({
          path: '/activity/search'
        })
      }
    },
    searchShop () {
      this.searchVal = '店铺'
      this.searchPro()
    },
    findSearchHistory() {
      if(this.isLogin){
        getHistory().then(res => {
          this.historyList = res.data.data
          this.showHistory = this.historyList.length > 0
        }).catch(res => {

        })
      }
    },
    historyDelAll () {
      this.$confirm('此操作将清空搜索记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteAllSearch()
      }).catch(() => {})
    },
    deleteAllSearch () {
      deleteAllSearch().then((res) => {
        this.historyList = res.data.data
      })
    },
    historyKeyword(search){
      let obj = {
        keyword: search,
        searchVal: this.searchVal
      }

      this.setSearchObj(obj)
      this.$router.push({
        path: '/activity/search'
      })
    },
    mycart(){
      if (Cookie.get('token')) {
        this.$router.push({path: '/shopping-trolley'})
      } else {
        this.$router.push({path: '/login?rtn=' + encodeURIComponent('/shopping-trolley')})
      }
    }
  },
};
</script>

<style lang="scss" scoped>
  .my-header{
    height: 120px;
    width: 1200px;
    margin: 0 auto;

    .logo-div{
      position: relative;
      .logo{
        width: 300px;
        margin-top: 20px;
      }
      span{
        font-size: 26px;
        color: $mainColor;
        position: absolute;
        top: -20px;
        right: -136px;
        width: 120px;
      }
    }

    .right{
      float: right;
      margin-top: 41px;
      .search{
        width: 494px;
        height: 50px;
        line-height: 54px;
        border: 3px solid $mainColor;
        border-radius: 5px;
        float: left;
        display: flex;
        position: relative;

        .searchRight{
          flex: 1;
          input{
            padding-left: 15px;
            font-size: 18px;
            color: #333;
            line-height: 35px;
            width: 100%;
          }
        }
        .historyBox{
          width: 494px;
          position: absolute;
          height: 210px;
          border: 3px solid $mainColor;
          top: 52px;
          left: -3px;
          border-top: 0;
          overflow: hidden;
          background-color: #fff;
          z-index: 999;
          .deleteBtn{
            position: absolute;
            bottom: 0;
            right: 10px;
            line-height: 25px;
            label{
              line-height: 25px;
              cursor: pointer;
            }
          }
          ul{
            overflow: hidden;
            li{
              width: 90%;
              padding: 0 20px;
              color: #999;
              cursor: pointer;
              float: left;
              line-height: 35px;
              font-size: 18px;

              &:hover{
                color: $mainColor;
              }

            }
          }
        }
      }
      .btn{
        font-size: 20px;
        line-height: 54px;
        padding: 0 15px;
        background-color: $mainColor;
        color: #fff;
        margin-top: -1px;
        margin-right: -1px;
      }
      .cartbtn{
        i{
          color: #c91723;
        }
        span{
          background-color: #c91723;
          color: #fff;
          border-radius: 17px;
          padding: 0 5px;
          font-size: 17px;
        }
        float: right;
        margin-left: 15px;
        line-height: 55px;
        height: 55px;
        border-radius: 5px;
        color: #000;
        background-color: #FFF;
        border: 1px solid #ccc;
      }
    }

  }
.userCenter {
  background-color: #fafafa;
  width: 100%;
  padding-top: 30px;
  display: flex;
  padding-bottom: 140px;
  .leftMenu {
    width: 186px;
    border: 1px solid #e5e5e5;
    margin-right: 16px;
    float: left;
    .leftMenuBox {
      >>> .el-menu {
        border-right: none;
        padding-bottom: 20px;
      }
      >>> .el-menu-item-group__title{
        font-size: 18px;
        color: #000;
        padding-top: 30px;
      }
      >>> .el-menu-item {
        height: 35px;
        line-height: 35px;
        display: block;
        &:hover{
          background-color: #eef7ff;
        }
        .title {
          width: 100%;
          padding-left: 36px;
          position: relative;
          .svg-icon {
            position: absolute;
            top: -6px;
            left: 20px;
          }
        }
        .tip {
          height: 18px;
          line-height: 18px;
          border-radius: 9px;
          color: #ffffff;
          font-size: 12px;
          padding: 0 5px;
          background-color: $mainGlod;
          position: absolute;
          right: -18px;
          top: -8px;
        }
      }
      >>> .is-active {
        .title {
          border-left: 4px solid $mainGlod;
          box-sizing: content-box;
          padding-left: 32px;
        }
      }
    }
  }
  .userCenterInfo {
    width: 990px;
    float: right;
    background-color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/userCenter/userCenter.vue